import React from 'react';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

class NotFound extends React.Component {
    render() {
        return (
            <React.Fragment>
                <div style={{ textAlign: 'center' }}>
                    <h1 style={{ fontSize: '80px', marginTop: 0, paddingTop: '20px' }}>404</h1>
                    <h2>PAGE NOT FOUND</h2>
                    <p>The page you are looking for might have been removed, had its name changed or is temporarily unavailable</p>
                    <p>Try going back to the main page</p>
                    <Link to="/"><Button bsStyle="primary">Go back</Button></Link>
                </div>
            </React.Fragment>
        );
    }
}

export default NotFound;



// WEBPACK FOOTER //
// ./src/areas/shared/errors/notFound/NotFound.js